import React from 'react';

import ThumbnailGridSmall from './ThumbnailGridSmall';

import useGenesisNoundleBalance from '../hooks/useGenesisNoundleBalance';
import useCompanionBalance from '../hooks/useCompanionBalance';
import useEvilNoundleBalance from '../hooks/useEvilNoundleBalance';

import useStakedNoundles from '../hooks/useStakedNoundles';
import useUnstakedNoundles from '../hooks/useUnstakedNoundles';
import useStakedCompanions from '../hooks/useStakedCompanions';
import useUnstakedCompanions from '../hooks/useUnstakedCompanions';
import useStakedEvilNoundles from '../hooks/useStakedEvilNoundles';
import useUnstakedEvilNoundles from '../hooks/useUnstakedEvilNoundles';
import Link from 'next/link';

const YourCollectionPanel = () => {
  const legacyNoundleBalance = useGenesisNoundleBalance();
  const stakedNoundles = useStakedNoundles();
  const unstakedNoundles = useUnstakedNoundles();
  const allNoundles = [...stakedNoundles, ...unstakedNoundles];

  const legacyCompanionBalance = useCompanionBalance();
  const stakedCompanions = useStakedCompanions();
  const unstakedCompanions = useUnstakedCompanions();
  const allCompanions = [...stakedCompanions, ...unstakedCompanions];

  const legacyEvilNoundleBalance = useEvilNoundleBalance();
  const stakedEvilNoundles = useStakedEvilNoundles();
  const unstakedEvilNoundles = useUnstakedEvilNoundles();
  const allEvilNoundles = [...stakedEvilNoundles, ...unstakedEvilNoundles];

  const genesisNoundleBalance =
    legacyNoundleBalance + stakedNoundles.length + unstakedNoundles.length;

  const companionBalance =
    legacyCompanionBalance +
    stakedCompanions.length +
    unstakedCompanions.length;

  const evilNoundleBalance =
    legacyEvilNoundleBalance +
    stakedEvilNoundles.length +
    unstakedEvilNoundles.length;

  return <>
    <h2 className="display-4 title mb-3">Your team</h2>
    <p>
      You have <strong>{genesisNoundleBalance}</strong> Noundles,{' '}
      <strong>{companionBalance}</strong> Frendles and{' '}
      <strong>{evilNoundleBalance}</strong> Ruggles.
    </p>
    <div className="d-flex flex-wrap justify-content-left">
      <ThumbnailGridSmall
        noundles={allNoundles}
        frendles={allCompanions}
        ruggles={allEvilNoundles}
      />
    </div>
    <p></p>
    <div>
      <a
        href="https://opensea.io/collection/noundles?search[toggles][0]=BUY_NOW"
        className="btn btn-primary rounded-pill px-4 my-1"
        target="_blank"
        rel="noreferrer"
      >
        Buy Noundles
      </a>{' '}
      <a
        href="https://opensea.io/collection/frendles?search[toggles][0]=BUY_NOW"
        className="btn btn-primary rounded-pill px-4 my-1"
        target="_blank"
        rel="noreferrer"
      >
        Buy Frendles
      </a>{' '}
      <a
        href="https://opensea.io/collection/ruggles?search[toggles][0]=BUY_NOW"
        className="btn btn-primary rounded-pill px-4 my-1"
        target="_blank"
        rel="noreferrer"
      >
        Buy Ruggles
      </a>{' '}
      <Link
        href="/dashboard/noundles"
        passHref
        className="btn btn-primary rounded-pill px-4 my-1">
        Stake
      </Link>
    </div>
  </>;
};

export default YourCollectionPanel;
